import React from 'react';
import ReviewTeaserCarousel from './ReviewTeaserCarousel';
import ReviewPreview from './ReviewTeaserPreview';
import Cta from './ReviewTeaserCTA';
import { useReviewContext } from '@hydra/common/context/review';

export default function ReviewTeaserPage ({ data }) {
  const { variant } = useReviewContext();
  return (
    <>
      <ReviewPreview data={data} />
      {
        !variant &&
        (
          <>
            <ReviewTeaserCarousel />
            <Cta
              btnText='free_review_choose_your_plan'
              icon
            />
          </>
        )
      }
    </>
  );
}
